export default __webpack_public_path__ + "static/media/find_token_id.ac51fca7.gif";